import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// Radix Slot expects plain className/style props; nav links use aria-current styling.
export const SidebarHint = ({ collapsed, label, children, testId }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip open={collapsed ? undefined : false}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="right" sideOffset={12} data-testid={testId} className="z-[60] max-w-64 bg-ink text-white normal-case tracking-normal">
        {label}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export const SidebarCollapseToggle = ({ collapsed, onToggle, sidebarId, testId }) => {
  const label = collapsed ? "Expand sidebar" : "Collapse sidebar";
  const Icon = collapsed ? PanelLeftOpen : PanelLeftClose;
  return (
    <button type="button" onClick={onToggle} data-testid={testId} aria-label={label}
      aria-expanded={!collapsed} aria-controls={sidebarId} title={label}
      className="hidden lg:inline-flex shrink-0 items-center justify-center h-9 w-9 rounded-lg text-ink/65 hover:text-ink hover:bg-sand-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-redline-500 transition-colors">
      <Icon className="h-5 w-5" strokeWidth={1.5} />
    </button>
  );
};
